import { ref, computed, onMounted, onUnmounted, nextTick, watch } from "vue";
import { defineStore } from "pinia";
import { useThrottleScroll } from "@/composables/useThrottleScroll";
import { metricScrolling, initTimeMetrics } from "@/utils/metrika";
import { useRoute } from "vue-router";
import { useSettingsStore } from "./storeSettings";

export const useScrollStore = defineStore("scroll", () => {

	const { throttleScroll } = useThrottleScroll();
	const route = useRoute();
	const storeSettings = useSettingsStore();

	const header = ref(null);
	const headerProfile = ref(null);
	const headerFixed = ref(false);
	const fixedButton = ref(null);
	const isFixedButton = ref(true);
	const footer = ref(null);
	const scrollPercent = ref(0)
	const sentMetrics = ref(new Set());
	const isProfilePage = computed(() => route.name === "profile");
	const paddingTop = computed(() => {
		const height = header.value?.offsetHeight;

		return `${height || 70}px`;
	});

	if (typeof window !== 'undefined') {
		initTimeMetrics(sentMetrics.value);
	}

	const handleScroll = () => {
		headerFixed.value = window.scrollY > 0;
		// headerFixed.value = (window.scrollY + header.value.offsetHeight) > header.value.offsetHeight;
	};

	const hideFixedButton = () => {
		const footerRect = footer.value.getBoundingClientRect();
		const buttonRect = fixedButton.value?.getBoundingClientRect();

		if (Math.abs(footerRect?.top) <= Math.abs(buttonRect?.bottom)) {
			isFixedButton.value = false;
		} else {
			isFixedButton.value = true;
		}
	};

	const checkPositionScroll = () => {
		const scrollTop = window.scrollY
		const scrollHeight = document.documentElement.scrollHeight
		const clientHeight = document.documentElement.clientHeight

		const percent = (scrollTop / (scrollHeight - clientHeight)) * 100
		scrollPercent.value = Math.min(100, Math.max(0, Math.round(percent)))
		metricScrolling(scrollPercent.value, sentMetrics.value)
	};


	function updatePadding() {
		nextTick(() => {
			// paddingTop.value = header.value?.offsetHeight + "px" ;
		});
	}

	const onScroll = () => {
		checkPositionScroll();
		throttleScroll(() => {
			handleScroll();
			hideFixedButton();
		});
	};

	// onMounted(() => {
	// 	window.addEventListener("scroll", onScroll);
	// 	updatePadding()
	// });

	// onUnmounted(() => {
	// 	window.removeEventListener("scroll", onScroll);
	// 	updatePadding()
	// });
	return {
		handleScroll,
		updatePadding,
		onScroll,
		checkPositionScroll,

		header,
		headerProfile,
		headerFixed,
		isProfilePage,
		footer,
		fixedButton,
		isFixedButton,
		paddingTop,
	};
});
